<div class="profile_information--content">
  <div class="flex-row-container profile_information--sub-tabs">
    <button
      type="button"
      appButton="small"
      [ngClass]="{ 'profile_information--sub-tab-selected': tabSelected === 0 }"
      (click)="showTabContent(0)"
    >
      <span i18n="@@ProfileInformation-Air">Air</span>
    </button>
    <button
      type="button"
      appButton="small"
      [ngClass]="{ 'profile_information--sub-tab-selected': tabSelected === 1 }"
      (click)="showTabContent(1)"
    >
      <span i18n="@@ProfileInformation-Rail">Rail</span>
    </button>
    <button
      type="button"
      appButton="small"
      [ngClass]="{ 'profile_information--sub-tab-selected': tabSelected === 2 }"
      (click)="showTabContent(2)"
    >
      <span i18n="@@ProfileInformation-Hotel">Hotel</span>
    </button>
    <button
      type="button"
      appButton="small"
      [ngClass]="{ 'profile_information--sub-tab-selected': tabSelected === 3 }"
      (click)="showTabContent(3)"
    >
      <span i18n="@@ProfileInformation-Car">Car</span>
    </button>
  </div>

  <div [formGroup]="addNewLoyaltyForm">
    <div class="profile_information--input-container">
      <span class="profile_information--docs-loyalty-label">
        {{ addNewLoyaltyForm.get('type').value | translate | titlecase }}
      </span>
      <div class="profile_information--docs-loyalty-input-1">
        <select class="profile_information--wrapped-input" formControlName="carrier">
          <option value="" i18n="@@ProfileInformation-Select">Select...</option>
          @for (data of tabData; track data) {
            <option [value]="data.value">
              {{ data.label }}
            </option>
          }
        </select>
        <fa-icon [icon]="faChevronDown"></fa-icon>
      </div>
      <input
        class="profile_information--docs-loyalty-input-2"
        i18n-placeholder
        placeholder="Enter code"
        formControlName="code"
      />
      <div class="profile_information--docs-loyalty-label">
        <span i18n="@@ProfileInformation-Expiry">Expiry</span>
      </div>
      <span class="expiry_date">
        <div class="profile_information--input-wrapper">
          <ngbd-datepicker-i18n>
            <input
              class="profile_information--input profile_information--docs-loyalty-input-2"
              placeholder="Select a date"
              i18n-placeholder
              #d="ngbDatepicker"
              ngbDatepicker
              firstDayOfWeek="7"
              [navigation]="'arrows'"
              (click)="d.toggle()"
              formControlName="expiryDate"
            />
            <fa-icon [icon]="faCalendar"></fa-icon>
          </ngbd-datepicker-i18n>
        </div>
      </span>
    </div>
  </div>

  <div class="profile_information--add-new-container">
    <button
      type="button"
      [disabled]="!isEditable"
      [class.disable-button]="!isEditable"
      (click)="addNewLoyalty()"
      appButton="small"
      i18n="@@ProfileInformation-AddNew"
    >
      Add New
    </button>
  </div>
</div>

@if (user && loyaltiesForm) {
  <div [formGroup]="loyaltiesForm" class="profile_information--content">
    <div formArrayName="loyaltyCodes">
      <div class="profile_information--content">
        <div class="profile_information--sub-header" i18n="@@ProfileInformation-Loyalties">
          Loyalties
        </div>
        @if (loyaltyCodes.length) {
          <table>
            <thead class="profile_information--table-thead">
              <tr>
                <th></th>
                <th i18n="@@ProfileInformation-LoyaltyProgram">Loyalty Program</th>
                <th i18n="@@ProfileInformation-Carrier">Carrier</th>
                <th i18n="@@ProfileInformation-LoyaltyCode">Loyalty Code</th>
                <th i18n="@@ProfileInformation-ExpiryDate">Expiry Date</th>
                <th i18n="@@ProfileInformation-Delete">Delete</th>
              </tr>
            </thead>
            <tbody class="profile_information--table-tbody">
              @for (loyalty of loyaltyCodes.controls; track loyalty; let i = $index) {
                <tr [formGroupName]="i">
                  <td>
                    @if (loyalty.get('type').value === serviceType.Hotel) {
                      <span><i class="ico-bed"></i></span>
                    }
                    @if (loyalty.get('type').value === serviceType.Flight) {
                      <span><i class="ico-flight"></i></span>
                    }
                    @if (loyalty.get('type').value === serviceType.Rail) {
                      <span><i class="ico-rail"></i></span>
                    }
                    @if (loyalty.get('type').value === serviceType.Car) {
                      <span><i class="ico-car"></i></span>
                    }
                  </td>
                  <td>
                    {{ loyalty.get('type').value }}
                    <span i18n="@@ProfileInformation-LOYALTYPROGRAMS">LOYALTY PROGRAMS</span>
                  </td>
                  <td>{{ loyalty.get('carrier').value }}</td>
                  <td>{{ loyalty.get('code').value }}</td>
                  <td>{{ loyalty.get('expiryDate').value | sabsDate: 1 }}</td>
                  <td>
                    <button
                      class="mat-stroked-button"
                      [disabled]="!isEditable"
                      [class.disable-button]="!isEditable"
                      (click)="deleteLoyalty(i)"
                    >
                      <span i18n="@@ProfileInformation-Delete">Delete</span>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="no-data-container" i18n="@@ProfileInformation-No-loyalties-to-display">
            No loyalties to display
          </p>
        }
      </div>
    </div>
  </div>
}
